/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AuthenticatedAprovacoesRouteImport } from './routes/_authenticated/aprovacoes'
import { Route as AuthenticatedAuditoriaRouteImport } from './routes/_authenticated/auditoria'
import { Route as AuthenticatedCadastrosRouteImport } from './routes/_authenticated/cadastros'
import { Route as AuthenticatedConciliacaoRouteImport } from './routes/_authenticated/conciliacao'
import { Route as AuthenticatedContratosRouteImport } from './routes/_authenticated/contratos'
import { Route as AuthenticatedIntercompanyRouteImport } from './routes/_authenticated/intercompany'
import { Route as AuthenticatedOrcamentoRouteImport } from './routes/_authenticated/orcamento'
import { Route as AuthenticatedPainelRouteImport } from './routes/_authenticated/painel'
import { Route as AuthenticatedLancamentosIndexRouteImport } from './routes/_authenticated/lancamentos/index'
import { Route as AuthenticatedLancamentosNovoRouteImport } from './routes/_authenticated/lancamentos/novo'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAprovacoesRoute = AuthenticatedAprovacoesRouteImport.update({
  id: '/aprovacoes',
  path: '/aprovacoes',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAuditoriaRoute = AuthenticatedAuditoriaRouteImport.update({
  id: '/auditoria',
  path: '/auditoria',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedCadastrosRoute = AuthenticatedCadastrosRouteImport.update({
  id: '/cadastros',
  path: '/cadastros',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedConciliacaoRoute =
  AuthenticatedConciliacaoRouteImport.update({
    id: '/conciliacao',
    path: '/conciliacao',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedContratosRoute = AuthenticatedContratosRouteImport.update({
  id: '/contratos',
  path: '/contratos',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedIntercompanyRoute =
  AuthenticatedIntercompanyRouteImport.update({
    id: '/intercompany',
    path: '/intercompany',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOrcamentoRoute = AuthenticatedOrcamentoRouteImport.update({
  id: '/orcamento',
  path: '/orcamento',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedPainelRoute = AuthenticatedPainelRouteImport.update({
  id: '/painel',
  path: '/painel',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedLancamentosIndexRoute =
  AuthenticatedLancamentosIndexRouteImport.update({
    id: '/lancamentos/',
    path: '/lancamentos/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLancamentosNovoRoute =
  AuthenticatedLancamentosNovoRouteImport.update({
    id: '/lancamentos/novo',
    path: '/lancamentos/novo',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/aprovacoes': typeof AuthenticatedAprovacoesRoute
  '/auditoria': typeof AuthenticatedAuditoriaRoute
  '/cadastros': typeof AuthenticatedCadastrosRoute
  '/conciliacao': typeof AuthenticatedConciliacaoRoute
  '/contratos': typeof AuthenticatedContratosRoute
  '/intercompany': typeof AuthenticatedIntercompanyRoute
  '/orcamento': typeof AuthenticatedOrcamentoRoute
  '/painel': typeof AuthenticatedPainelRoute
  '/lancamentos/novo': typeof AuthenticatedLancamentosNovoRoute
  '/lancamentos/': typeof AuthenticatedLancamentosIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/aprovacoes': typeof AuthenticatedAprovacoesRoute
  '/auditoria': typeof AuthenticatedAuditoriaRoute
  '/cadastros': typeof AuthenticatedCadastrosRoute
  '/conciliacao': typeof AuthenticatedConciliacaoRoute
  '/contratos': typeof AuthenticatedContratosRoute
  '/intercompany': typeof AuthenticatedIntercompanyRoute
  '/orcamento': typeof AuthenticatedOrcamentoRoute
  '/painel': typeof AuthenticatedPainelRoute
  '/lancamentos/novo': typeof AuthenticatedLancamentosNovoRoute
  '/lancamentos': typeof AuthenticatedLancamentosIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/auth': typeof AuthRoute
  '/_authenticated/aprovacoes': typeof AuthenticatedAprovacoesRoute
  '/_authenticated/auditoria': typeof AuthenticatedAuditoriaRoute
  '/_authenticated/cadastros': typeof AuthenticatedCadastrosRoute
  '/_authenticated/conciliacao': typeof AuthenticatedConciliacaoRoute
  '/_authenticated/contratos': typeof AuthenticatedContratosRoute
  '/_authenticated/intercompany': typeof AuthenticatedIntercompanyRoute
  '/_authenticated/orcamento': typeof AuthenticatedOrcamentoRoute
  '/_authenticated/painel': typeof AuthenticatedPainelRoute
  '/_authenticated/lancamentos/novo': typeof AuthenticatedLancamentosNovoRoute
  '/_authenticated/lancamentos/': typeof AuthenticatedLancamentosIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/aprovacoes'
    | '/auditoria'
    | '/cadastros'
    | '/conciliacao'
    | '/contratos'
    | '/intercompany'
    | '/orcamento'
    | '/painel'
    | '/lancamentos/novo'
    | '/lancamentos/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/aprovacoes'
    | '/auditoria'
    | '/cadastros'
    | '/conciliacao'
    | '/contratos'
    | '/intercompany'
    | '/orcamento'
    | '/painel'
    | '/lancamentos/novo'
    | '/lancamentos'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/auth'
    | '/_authenticated/aprovacoes'
    | '/_authenticated/auditoria'
    | '/_authenticated/cadastros'
    | '/_authenticated/conciliacao'
    | '/_authenticated/contratos'
    | '/_authenticated/intercompany'
    | '/_authenticated/orcamento'
    | '/_authenticated/painel'
    | '/_authenticated/lancamentos/novo'
    | '/_authenticated/lancamentos/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  AuthRoute: typeof AuthRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/aprovacoes': {
      id: '/_authenticated/aprovacoes'
      path: '/aprovacoes'
      fullPath: '/aprovacoes'
      preLoaderRoute: typeof AuthenticatedAprovacoesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/auditoria': {
      id: '/_authenticated/auditoria'
      path: '/auditoria'
      fullPath: '/auditoria'
      preLoaderRoute: typeof AuthenticatedAuditoriaRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cadastros': {
      id: '/_authenticated/cadastros'
      path: '/cadastros'
      fullPath: '/cadastros'
      preLoaderRoute: typeof AuthenticatedCadastrosRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/conciliacao': {
      id: '/_authenticated/conciliacao'
      path: '/conciliacao'
      fullPath: '/conciliacao'
      preLoaderRoute: typeof AuthenticatedConciliacaoRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/contratos': {
      id: '/_authenticated/contratos'
      path: '/contratos'
      fullPath: '/contratos'
      preLoaderRoute: typeof AuthenticatedContratosRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/intercompany': {
      id: '/_authenticated/intercompany'
      path: '/intercompany'
      fullPath: '/intercompany'
      preLoaderRoute: typeof AuthenticatedIntercompanyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/orcamento': {
      id: '/_authenticated/orcamento'
      path: '/orcamento'
      fullPath: '/orcamento'
      preLoaderRoute: typeof AuthenticatedOrcamentoRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/painel': {
      id: '/_authenticated/painel'
      path: '/painel'
      fullPath: '/painel'
      preLoaderRoute: typeof AuthenticatedPainelRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/lancamentos/': {
      id: '/_authenticated/lancamentos/'
      path: '/lancamentos'
      fullPath: '/lancamentos/'
      preLoaderRoute: typeof AuthenticatedLancamentosIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/lancamentos/novo': {
      id: '/_authenticated/lancamentos/novo'
      path: '/lancamentos/novo'
      fullPath: '/lancamentos/novo'
      preLoaderRoute: typeof AuthenticatedLancamentosNovoRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAprovacoesRoute: typeof AuthenticatedAprovacoesRoute
  AuthenticatedAuditoriaRoute: typeof AuthenticatedAuditoriaRoute
  AuthenticatedCadastrosRoute: typeof AuthenticatedCadastrosRoute
  AuthenticatedConciliacaoRoute: typeof AuthenticatedConciliacaoRoute
  AuthenticatedContratosRoute: typeof AuthenticatedContratosRoute
  AuthenticatedIntercompanyRoute: typeof AuthenticatedIntercompanyRoute
  AuthenticatedOrcamentoRoute: typeof AuthenticatedOrcamentoRoute
  AuthenticatedPainelRoute: typeof AuthenticatedPainelRoute
  AuthenticatedLancamentosNovoRoute: typeof AuthenticatedLancamentosNovoRoute
  AuthenticatedLancamentosIndexRoute: typeof AuthenticatedLancamentosIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAprovacoesRoute: AuthenticatedAprovacoesRoute,
  AuthenticatedAuditoriaRoute: AuthenticatedAuditoriaRoute,
  AuthenticatedCadastrosRoute: AuthenticatedCadastrosRoute,
  AuthenticatedConciliacaoRoute: AuthenticatedConciliacaoRoute,
  AuthenticatedContratosRoute: AuthenticatedContratosRoute,
  AuthenticatedIntercompanyRoute: AuthenticatedIntercompanyRoute,
  AuthenticatedOrcamentoRoute: AuthenticatedOrcamentoRoute,
  AuthenticatedPainelRoute: AuthenticatedPainelRoute,
  AuthenticatedLancamentosNovoRoute: AuthenticatedLancamentosNovoRoute,
  AuthenticatedLancamentosIndexRoute: AuthenticatedLancamentosIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  AuthRoute: AuthRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
